import { Box } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    maxWidth: 140,
    minHeight: 30,
    display: 'grid',
    placeContent: 'center',
  },
}))

interface Props {
  logo: React.ReactElement
}

/**
 * This component displays the header content of an extension which is a logo.
 */
const HeaderContent: React.FC<Props> = ({ logo }) => {
  const { classes } = useStyles()

  return <Box className={classes.container}>{logo}</Box>
}

export default HeaderContent
